import { render, staticRenderFns } from "./EntryText.vue?vue&type=template&id=a044e806&scoped=true"
import script from "./EntryText.vue?vue&type=script&lang=js"
export * from "./EntryText.vue?vue&type=script&lang=js"
import style0 from "./EntryText.vue?vue&type=style&index=0&id=a044e806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a044e806",
  null
  
)

export default component.exports